import { authenticationApi } from "../api/authentication.api";

export default function SocialAuthButtons() {
    return (
        <>
            <div className="ogm-divider">OR</div>

            <button
                type="button"
                className="ogm-google-btn"
                onClick={() => {
                    window.location.href = authenticationApi.googleOAuthUrl();
                }}
            >
                <img src="/google.svg" alt="" aria-hidden="true" />
                Continue with Google
            </button>
        </>
    );
}
